module.exports = __webpack_public_path__ + "img/16.50f56ba5.webp";